import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/propertyListing.css";

import useScrollRestore from "../hooks/useScrollRestore";
import usePropertyListing from "../hooks/usePropertyListing";
import { useFavorites } from "../Components/Context/FavoritesContext";

import PropertyListingHeader from "../Components/properties/PropertyListingHeader";
import PropertyFilters from "../Components/properties/PropertyFilters";
import PropertyGrid from "../Components/properties/PropertyGrid";
import LoadMoreButton from "../Components/properties/LoadMoreButton";

const PAGE_KEY = "comprar-imovel";
const pageFilter = (item) => item.imovelInfo?.modalidade === "Venda";

function ComprarImovel() {
  const navigate = useNavigate();
  const { favorites, addFavorite, removeFavorite } = useFavorites();

  const listing = usePropertyListing({ pageKey: PAGE_KEY, pageFilter });

  const saveScroll = useScrollRestore(
    `scroll-${PAGE_KEY}`,
    listing.visibleProperties.length > 0
  );

  const toggleFavorite = (property) => {
    if (
      favorites.some(
        (fav) => fav.imovelInfo?.codigo === property.imovelInfo?.codigo
      )
    ) {
      removeFavorite(property.imovelInfo?.codigo);
    } else {
      addFavorite(property);
    }
  };

  const handleNavigate = (codigo) => {
    saveScroll();
    navigate(`/imovel/${codigo}`);
  };

  return (
    <div className="listing-page">
      <PropertyListingHeader
        backLabel="Comprar"
        title="Imóveis para comprar"
        subtitle="Encontre o imóvel ideal para viver ou investir."
      />

      <PropertyFilters
        sort={listing.sort}
        onSortChange={listing.setSort}
        city={listing.city}
        onCityChange={listing.setCity}
        cityOptions={listing.cityOptions}
        neighborhood={listing.neighborhood}
        onNeighborhoodChange={listing.setNeighborhood}
        neighborhoodOptions={listing.neighborhoodOptions}
        hasActiveFilters={listing.hasActiveFilters}
        onClear={listing.clearFilters}
      />

      {!listing.loading && (
        <p className="listing-counter">
          <strong>{listing.filteredProperties.length}</strong> imóveis
          encontrados
        </p>
      )}

      <PropertyGrid
        properties={listing.visibleProperties}
        loading={listing.loading}
        favorites={favorites}
        onToggleFavorite={toggleFavorite}
        onNavigate={handleNavigate}
        hasActiveFilters={listing.hasActiveFilters}
        onClearFilters={listing.clearFilters}
      />

      <LoadMoreButton
        onClick={listing.loadMore}
        shown={listing.visibleProperties.length}
        total={listing.filteredProperties.length}
      />
    </div>
  );
}

export default ComprarImovel;
